import _0x3a6808 from'react';export default _0x3a6808['createContext'](null);